module.exports = __webpack_public_path__ + "static/media/OrderDetailsScreen.3c95b754.png";